module.exports = __webpack_public_path__ + "static/media/square-regular~ZGzDWMGe.8dd8544b.svg";